const getters = {
    getAutenticacao: state => state.autenticacao,
    getCentroCusto: state => state.centroCusto,
    getCliente: state => state.cliente,
    getCustomer: state => state.customer,
    getLoading: state => state.loading,
    getLotacao: state => state.lotacao,
    getMenu: state => state.menu,
    getShowExitFormConfirmation: state => state.showExitFormConfirmation,
    getSidebar: state => state.sidebar,
}

export default getters